if (!customElements.get('chapon-recently-viewed')) {
  customElements.define('chapon-recently-viewed', class extends HTMLElement {
    connectedCallback() {
      if (this.loaded) return;
      const key = 'theme:recently-viewed-products';
      const current = Number(this.dataset.productId);
      let history = [];
      try {
        const stored = JSON.parse(localStorage.getItem(key) || '[]');
        if (Array.isArray(stored)) history = [...new Set(stored.filter(id => Number.isSafeInteger(id) && id > 0))].slice(0, 20);
      } catch (error) { console.warn('Recently viewed history unavailable', error); }
      if (Number.isSafeInteger(current) && current > 0) {
        history = [current, ...history.filter(id => id !== current)].slice(0, 20);
        try { localStorage.setItem(key, JSON.stringify(history)); }
        catch (error) { console.warn('Recently viewed history unavailable', error); }
      }
      this.ids = history.filter(id => id !== current);
      if (!this.ids.length) return;
      this.controller = new AbortController();
      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(entries => {
          if (entries.some(entry => entry.isIntersecting)) { this.observer.disconnect(); this.load(); }
        }, { rootMargin: '300px' });
        this.observer.observe(this);
      } else this.load();
    }
    disconnectedCallback() { this.controller?.abort(); this.observer?.disconnect(); }
    async load() {
      try {
        const url = new URL(this.dataset.url, window.location.origin);
        url.searchParams.set('type', 'product');
        url.searchParams.set('q', this.ids.map(id => `id:${id}`).join(' OR '));
        url.searchParams.set('section_id', this.dataset.section);
        url.searchParams.set('options[unavailable_products]', 'show');
        const response = await fetch(url, { signal: this.controller.signal, priority: 'low' });
        if (!response.ok) throw new Error(`Recently viewed HTTP ${response.status}`);
        const content = new DOMParser().parseFromString(await response.text(), 'text/html')
          .querySelector('chapon-recently-viewed');
        if (!content) throw new Error('Recently viewed section missing');
        this.innerHTML = content.innerHTML;
        this.loaded = true;
      } catch (error) {
        if (error.name !== 'AbortError') console.error(this.dataset.error, error);
      }
    }
  });
}
